<template>
    <div class="layout-tiles" :class="layoutClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutTiles',
    props: {
        dividerColor: {
            required: false,
            type: String,
            default: 'divide-gray-100',
        },
    },
    computed: {
        layoutClasses() {
            const cls = {};
            cls['divide-y'] = true;
            cls[this.dividerColor] = true;
            return cls;
        },
    },
};
</script>
